import { api } from '@/lib/axios';

/**
 * AP-29-F — Anfrage beim Betreiber (ADMIN).
 *
 * Die Anfrage schaltet nichts frei; sie erreicht den Betreiber, der in seiner
 * Konsole bucht. `ALREADY_SENT` ist kein Fehler, sondern die Auskunft, dass
 * dieselbe Anfrage heute schon draußen ist.
 */
/**
 * `INTEREST` ist keine Bestellung: Das Modul gibt es noch nicht. Der Betreiber
 * kann daraufhin nichts freischalten — er erfährt nur, worauf ein Betrieb wartet.
 */
export type ModuleRequestKind = 'MODULE' | 'SEATS' | 'INTEREST';

export interface ModuleRequestResult {
  status: 'SENT' | 'ALREADY_SENT';
  requestedAt: string;
}

export const moduleRequestsApi = {
  create: async (payload: {
    moduleKey: string;
    kind: ModuleRequestKind;
    additionalSeats?: number;
    note?: string;
  }): Promise<ModuleRequestResult> => {
    const res = await api.post<ModuleRequestResult>('/module-requests', payload);
    return res.data;
  },
};
